import ServerError from '@/common/utils/errors/ServerError';
import { AxiosResponse } from 'axios';

export default class ValidationError extends ServerError {
  errorData?: ErrorData;

  constructor(response: CreateFetchResponse | AxiosResponse, body: ErrorBody) {
    super(response, body, undefined, 'Validation error');
    this.errorData = (this.body as ErrorBody)?.error?.data;
    this.message = (this.body as ErrorBody)?.error?.message
      || ((this.body as ErrorBody)?.message)
      || (response?.statusText)
      || 'Error';
  }
}
